<template>
  <div class="fill-height accent">
    <v-container>
      <v-row>
        <v-col>
          <p class="display-1">Perfil</p>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" class="pb-0">
          <p class="title">Cuenta</p>
        </v-col>
        <v-col cols="12" md="6" class="py-1">
          <BaseMyTextField
            v-model="miembro.nombres"
            label="Nombres *"
            :error-messages="nombresErrors"
            @input="$v.miembro.nombres.$touch()"
            @blur="$v.miembro.nombres.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" md="6" class="py-1">
          <BaseMyTextField
            v-model="miembro.apellidos"
            label="Apellidos *"
            :error-messages="apellidosErrors"
            @input="$v.miembro.apellidos.$touch()"
            @blur="$v.miembro.apellidos.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" md="6" class="py-1">
          <BaseMyTextField v-model="member.correo" label="Correo actual" disabled></BaseMyTextField>
        </v-col>
        <v-col cols="12" md="6" class="py-1">
          <BaseMyTextField
            v-model="miembro.correo"
            label="Correo nuevo *"
            :error-messages="correoErrors"
            @input="$v.miembro.correo.$touch()"
            @blur="$v.miembro.correo.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" v-if="updateErrorCorreo" class="d-flex justify-end py-0">
          <p class="error--text font-weight-bold body-2">
            <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
            {{updateErrorCorreo}}
          </p>
        </v-col>
        <v-col cols="12" class="d-flex justify-end pt-0">
          <BaseMyButton color="info" @click="cleanAccount">Limpiar</BaseMyButton>
          <BaseMyButton color="success" class="ml-2" @click="updateUser">
            <v-icon>mdi-content-save</v-icon>
          </BaseMyButton>
        </v-col>
      </v-row>
    </v-container>
    <v-container>
      <v-divider></v-divider>
      <v-row>
        <v-col cols="12" class="pb-0">
          <p class="title">Contraseña</p>
          <p
            class="overline"
          >Es necesario que ingreses tu contraseña actual para realizar este cambio</p>
        </v-col>
        <v-col cols="12" md="4" class="py-1">
          <BaseMyTextField
            v-model="miembro.password_antigua"
            label="Contraseña actual *"
            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show ? 'text' : 'password'"
            @click:append="show = !show"
            :error-messages="passwordAntiguaErrors"
            @input="$v.miembro.password_antigua.$touch()"
            @blur="$v.miembro.password_antigua.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" md="4" class="py-1">
          <BaseMyTextField
            v-model="miembro.password_nueva"
            label="Contraseña nueva *"
            :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
            :type="show2 ? 'text' : 'password'"
            @click:append="show2 = !show2"
            :error-messages="passwordNuevaErrors"
            @input="$v.miembro.password_nueva.$touch()"
            @blur="$v.miembro.password_nueva.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" md="4" class="py-1">
          <BaseMyTextField
            v-model="miembro.rePassword"
            label="Repita contraseña *"
            :type="show2 ? 'text' : 'password'"
            :error-messages="rePasswordErrors"
            @input="$v.miembro.rePassword.$touch()"
            @blur="$v.miembro.rePassword.$touch()"
            required
          ></BaseMyTextField>
        </v-col>
        <v-col cols="12" v-if="updateError" class="d-flex justify-end py-0">
          <p class="error--text font-weight-bold body-2">
            <v-icon color="error" class="mr-2">mdi-alert-circle</v-icon>
            {{updateError}}
          </p>
        </v-col>
        <v-col cols="12" class="d-flex justify-end pt-0">
          <BaseMyButton color="info" @click="clean">Limpiar</BaseMyButton>
          <BaseMyButton color="success" class="ml-2" @click="updateUser('password')">
            <v-icon>mdi-content-save</v-icon>
          </BaseMyButton>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import store from "@/store";
import { mapState } from "vuex";

import { validationMixin } from "vuelidate";
import { required, email, sameAs } from "vuelidate/lib/validators";

export default {
  name: "Profile",
  mixins: [validationMixin],
  validations: {
    miembro: {
      nombres: { required },
      apellidos: { required },
      correo: { email },
      password_antigua: { required },
      password_nueva: { required },
      rePassword: {
        sameAsPassword: sameAs("password_nueva")
      }
    }
  },
  created() {
    this.initializeAccount();
  },
  data() {
    return {
      updateError: "",
      updateErrorCorreo: "",
      show: false,
      show2: false,
      miembro: {
        nombres: "",
        apellidos: "",
        correo: "",
        password_antigua: "",
        password_nueva: "",
        rePassword: ""
      }
    };
  },
  computed: {
    ...mapState("companies/company", ["member"]),
    nombresErrors() {
      const errors = [];
      if (!this.$v.miembro.nombres.$dirty) return errors;
      !this.$v.miembro.nombres.required && errors.push("Campo necesario");
      return errors;
    },
    apellidosErrors() {
      const errors = [];
      if (!this.$v.miembro.apellidos.$dirty) return errors;
      !this.$v.miembro.apellidos.required && errors.push("Campo necesario");
      return errors;
    },
    correoErrors() {
      const errors = [];
      if (!this.$v.miembro.correo.$dirty) return errors;
      !this.$v.miembro.correo.email && errors.push("Ingrese un correo valido");
      return errors;
    },
    passwordAntiguaErrors() {
      const errors = [];
      if (!this.$v.miembro.password_antigua.$dirty) return errors;
      !this.$v.miembro.password_antigua.required &&
        errors.push("Campo necesario");
      return errors;
    },
    passwordNuevaErrors() {
      const errors = [];
      if (!this.$v.miembro.password_nueva.$dirty) return errors;
      !this.$v.miembro.password_nueva.required &&
        errors.push("Campo necesario");
      return errors;
    },
    rePasswordErrors() {
      const errors = [];
      if (!this.$v.miembro.rePassword.$dirty) return errors;
      !this.$v.miembro.rePassword.sameAsPassword &&
        errors.push("Las contraseñas no coinciden");
      return errors;
    }
  },
  methods: {
    initializeAccount() {
      this.miembro = Object.assign(
        {},
        {
          nombres: this.member.nombres,
          apellidos: this.member.apellidos
        }
      );
    },
    updateUser(type) {
      if (type === "password") {
        this.$v.miembro.password_antigua.$touch();
        this.$v.miembro.password_nueva.$touch();
        this.$v.miembro.rePassword.$touch();
        if (
          this.$v.miembro.password_antigua.$invalid ||
          this.$v.miembro.password_nueva.$invalid ||
          this.$v.miembro.rePassword.$invalid
        )
          return;
      } else {
        if (this.miembro.correo) {
          this.$v.miembro.correo.$touch();
          if (this.$v.miembro.correo.$invalid) return;
        } else {
          this.miembro.correo = this.member.correo;
        }
      }
      this.$store
        .dispatch("companies/company/updateMemberProfile", this.miembro)
        .then(response => {
          this.$store.commit("SET_ALERT", {
            color: "green",
            text: "Información actualizada",
            visible: true
          });
          this.cleanAll();
        })
        .catch(error => {
          this.$store.commit("SET_ALERT", {
            color: "red",
            text: "Error al actualizar la información",
            visible: true
          });
          if (type === "correo") {
            this.updateErrorCorreo = error.response.data.message;
          } else {
            this.updateError = error.response.data.message;
          }
        });
    },
    clean() {
      this.miembro.password_antigua = "";
      this.miembro.password_nueva = "";
      this.miembro.rePassword = "";

      this.$v.miembro.password_antigua.$reset();
      this.$v.miembro.password_nueva.$reset();
      this.$v.miembro.rePassword.$reset();
      this.updateError = "";
    },
    cleanAccount() {
      this.miembro.correo = "";
      this.$v.miembro.nombres.$reset();
      this.$v.miembro.apellidos.$reset();
      this.$v.miembro.correo.$reset();
      this.updateErrorCorreo = "";
    },

    cleanAll() {
      this.cleanAccount();
      this.clean();
    }
  }
};
</script>

<style>
</style>